import { ProviderParametersFragment } from '../../../generated/graphql'
import { PrimaryHourlyEnergyFlow } from '../../HourlyEnergyFlow'
import { HourlyVariables, Provider } from './Provider'

export type SingleTypeHourlyVariables = HourlyVariables & {
  remainingDemand: PrimaryHourlyEnergyFlow
}

/**
 * Base provider class for providers that provide for one energy type.
 */
export abstract class SingleTypeProvider<
  TParameters extends ProviderParametersFragment = ProviderParametersFragment,
  THourlyVariables extends SingleTypeHourlyVariables = SingleTypeHourlyVariables,
> extends Provider<TParameters, THourlyVariables> {
  /**
   * Providers may implement this to add their own hourly variables.
   */
  protected getHourlyVariables(
    hour: number,
    demands: PrimaryHourlyEnergyFlow[],
  ): THourlyVariables {
    if (demands.length !== 1) {
      throw new Error(
        'Single type provider can only provider for one energy type',
      )
    }

    return {
      remainingDemand: demands[0],
      outdoorTemperature: this.temperatureValues?.[hour],
    } as THourlyVariables
  }
}
